import { Link, Icon } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import * as Styles from './Button.module.css'

const Button = ({ icon, as, className, children, to, type, ...props }) => {
  const Tag = as ? as : 'button'

  const ButtonIcon = () => (
    <Icon
      className={`
        ${Styles[icon.position]}
        ${icon.color === 'primary' ? 'text-primary-600' : ''}
      `}
      name={icon.name}
    />
  )

  return (
    <Link to={to}>
      <Tag
        className={`${Styles[type]} ${Styles.icon || ''} ${className || ''}`}
        {...props}
      >
        {icon && icon.position === 'left' && <ButtonIcon />}
        {children}
        {icon && icon.position === 'right' && <ButtonIcon />}
      </Tag>
    </Link>
  )
}

Button.propTypes = {
  as: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  to: PropTypes.string,
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'outline',
    'text',
    'white',
    'light',
  ]),
}

export default Button
